<template>
  <transition name="modal">
    <div class="modal-mask" @click="$emit('close')">
      <div class="modal-wrapper">
        <div class="modal-container-sep" @click.stop>
          <div class="modal-header-sep">
            <slot name="cross">
              <v-icon style="float: right;" @click="$emit('close')">mdi-close</v-icon>
            </slot>
            <slot name="header">
              <p style="margin-bottom: 0;"> {{ $t("_pour_indiquer_") }}
                <img style="height: 20px" :src="getIconSource('polygon')" :alt="$t('button.polygon_alt')" />
                {{ $t("_en_cas_derreur_") }}
                <img style="height: 20px" :src="getIconSource('bin')" :alt="$t('button.bin_alt')" />
              </p>
            </slot>

          </div>

          <div class="modal-body-sep">
            <v-row style="height: 100%;">
              <v-col cols="7" class="map col">
                <l-map ref="refMap" class="small-map-sep" :zoom="zoom" :center="center" @update:zoom="zoomUpdated"
                  @update:center="centerUpdated" @update:bounds="boundsUpdated">
                  <custom-tile-layer :url="tileProviders.url" :attribution="tileProviders.attribution" :maxZoom="22"
                    :maxNativeZoom="18" />

                  <l-feature-group ref="featureGroup"></l-feature-group>
                  <l-marker ref="mapRef" :lat-lng="markerLatLng" @ready="map_ready">
                    <l-popup>
                      <b>
                        {{ site }}
                      </b>
                      <br />
                      {{ address }}
                      <br />
                      {{ postalCode }} , {{ city }}
                      <br />
                      <hr />
                      {{ markerLatLng[0] }},{{ markerLatLng[1] }}
                    </l-popup>
                  </l-marker>
                  <l-feature-group ref="featureGroup"></l-feature-group>
                  <l-polygon :lat-lngs="rectangleCoords" color='red' fillColor="none"
                    :options="{ zIndex: 0 }"></l-polygon>
                </l-map>
              </v-col>
              <v-col cols="5" style="display: flex" class="col">
                <table class="mpp">
                  <thead>
                    <tr>
                      <th>
                        {{ $t('_pdm_') }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="(item, index) in sortedPtDeMesure">
                      <tr :key="'row' + index"
                        :class="indexSelect === index ? 'ligneSelected' : (isAllocated(index) ? 'ligneAssociee' : 'ligneNonAssocie')">
                        <td @click="selecting(index)">
                          {{ getNamesFromId(item) }}
                        </td>
                        <td>
                          <button v-if="isAllocated(index)" @click="toggleOeil(index)"
                            :class="exandedIndexOeil === index ? 'eye-select' : 'eye'">
                            👁
                          </button>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
                <div class="modal-footer-sep">
                  <slot name="footer">
                    <v-btn :disabled="missingPoints()" style="float: right; right: 5px; "
                      @click="$emit('save', formes)">
                      {{ $t('_valider_') }}
                    </v-btn>
                  </slot>
                </div>
              </v-col>
            </v-row>


          </div>


        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { LMap, LFeatureGroup, LPolygon } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet-draw/dist/leaflet.draw.css';
import L from 'leaflet';
import 'leaflet-toolbar/dist/leaflet.toolbar.css'
import 'leaflet-toolbar';

import 'leaflet-distortableimage'
import 'leaflet-distortableimage/dist/leaflet.distortableimage.css'
import backend from '@/api/backend';

//Presque comme la tileLayer cloassique de esri mais ajouter différemment pour ajouter un zoom artificiel
const CustomTileLayer = {
  name: 'CustomTileLayer',
  props: ['url', 'attribution', 'maxZoom', 'maxNativeZoom'],
  mounted() {
    const tileLayer = L.tileLayer(this.url, {
      attribution: this.attribution,
      maxZoom: this.maxZoom,
      maxNativeZoom: this.maxNativeZoom,
      noWrap: true,
      tms: false,
    });

    tileLayer.addTo(this.$parent.mapObject);
  },
  render() {
    return null;
  }
};

export default {
  name: "Separation",

  props: {
    rectangleCoords: {
      required: true
    },
    ptDeMesure: {
      required: true
    },

    mpps: {
      required: true
    }
  },

  components: { LMap, CustomTileLayer, LFeatureGroup, LPolygon },

  async mounted() {
    this.$nextTick(async () => {
      //Ajoute la possibilité de dessiner sur la carte
      const map = this.$refs.refMap.mapObject;
      const featureGroup = this.$refs.featureGroup.mapObject;

      this.drawControl = new L.Control.Draw({
        edit: {
          featureGroup: featureGroup,
          edit: true,
          remove: true,
        },
        draw: {
          circle: false,
          marker: false,
          polyline: false,
          circlemarker: false,
          rectangle: false,
        },
      });

      map.addControl(this.drawControl);

      map.on('draw:created', (e) => this.onCreated(e));
      map.on('draw:deleted', (e) => this.onDeleted(e));
      for (let i = 0; i < this.ptDeMesure.length; i++) {
        this.formes.coordinates[i] = [];
      }

      //Ajoute la photo si il y en a une
      try {

        let corners = (await backend.get_mask_install(this.installation_id)).data
        let fileURL = URL.createObjectURL((await backend.get_mask_file_install(this.installation_id)).data)

        const map = this.$refs.refMap.mapObject

        const options = {
          corners: corners,
          suppressToolbar: true,
          editable: false,
          actions: [],
          mode: ''
        }

        this.overlay = L.distortableImageOverlay(fileURL, options).addTo(map)
        this.imageExiste = true
        URL.revokeObjectURL(fileURL);

      }
      catch (error) {
        console.error("Pas d'image à recuperer")
      }
    })
  },

  data() {
    return {
      installation_id: this.$route.params.id,
      url: "http://{s}.tile.osm.org/{z}/{x}/{y}.png",
      zoom: 18,
      markerLatLng: [0, 0],
      center: [48.866667, 2.333333],
      address: "8 rue de micheline",
      site: "Mon site",
      postalCode: "75000",

      city: "Paris",
      mapRef: null,
      bounds: null,

      tileProviders:
      {
        url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}.png",
        visible: true,
        name: "satelliteESRI",
        attribution: 'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
      },
      formes: {
        ptDeMesure: [],
        coordinates: [[]]
      },

      indexSelect: null,
      exandedIndexOeil: null,

    }
  },

  computed: {
    //retourne les mpp triées
    sortedPtDeMesure() {
      return [...this.ptDeMesure].sort((a, b) => {
        const [a1, a2] = a.split('-').map(Number);  // Extraire les parties numériques
        const [b1, b2] = b.split('-').map(Number);  // Extraire les parties numériques

        // Comparer d'abord la première partie, puis la deuxième si égalité
        if (a1 === b1) {
          return a2 - b2; 
        }
        return a1 - b1; 
      });
    },
  },

  watch: {
    exandedIndexOeil() {
      this.$refs.featureGroup.mapObject.eachLayer(polygone => {
        polygone.setStyle(this.getStylePolygon(polygone))
      })
    },
  },

  methods: {
    zoomUpdated(zoom) {
      this.zoom = zoom;
    },
    centerUpdated(center) {
      this.center = center;
    },
    boundsUpdated(bounds) {
      this.bounds = bounds;
    },
    map_ready() {
      this.$r
      const poly = L.polygon(this.rectangleCoords);
      this.$refs.refMap.mapObject.fitBounds(poly.getBounds());
    },

    //Crée un bloc, en lui attribuant ses mpp, et l'ajoute à la carte
    addPolygonToLayer(rectangle, index) {
      const polygon = L.polygon(rectangle);
      const prop = this.mpp_assigned[index];
      polygon.options.mpp = prop;
      polygon.id = index;
      polygon.on('click', () => {
        this.openModal(polygon);
      });
      polygon.bindTooltip(this.getTooltipText(polygon), {
        permanent: false,    // Le tooltip apparaîtra au survol
        direction: 'top',    // Position du tooltip par rapport au polygone
        offset: [0, -10]     // Décalage du tooltip
      });
      polygon.setStyle(this.getStylePolygon(polygon));
      this.$refs.featureGroup.mapObject.addLayer(polygon);
      this.nextId += 1;
    },

    onCreated(event) {
      if (this.indexSelect != null) {
        const layer = event.layer;

        layer.options.mpp = this.formes.ptDeMesure[this.indexSelect];
        layer.id = this.nextId;
        this.nextId += 1;

        layer.bindTooltip(this.getTooltipText(layer), {
          permanent: false,    // Le tooltip apparaîtra au survol
          direction: 'top',    // Position du tooltip par rapport au polygone
          offset: [0, -10]     // Décalage du tooltip
        });

        layer.setStyle(this.getStylePolygon(layer));
        this.$refs.featureGroup.mapObject.addLayer(layer);

        var latLngs = layer.getLatLngs();

        if (latLngs && latLngs.length > 0) {
          const flatLatLngs = latLngs[0].map(coord => [coord.lat, coord.lng]);

          flatLatLngs.push(flatLatLngs[0]);
          this.formes.coordinates[this.indexSelect].push(flatLatLngs);
        }

      }
      this.$forceUpdate();
    },

    getNamesFromId(id) {
      for(let i=0; i<this.mpps.length; i++ ){
        if(this.mpps[i].id===id){
          return this.mpps[i].mpp
        }
      }
    },

    getNamesFromIds(ids){
      let names=[]
      this.mpps.forEach((mpp) => {
        if(ids.includes(mpp.id))
          names.push(mpp.mpp)
      })
      return names
    },

    onDeleted(event) {

      const deletedLayers = event.layers;

      if (deletedLayers && deletedLayers.getLayers().length > 0) {
        deletedLayers.eachLayer((layer) => {
          this.$refs.featureGroup.mapObject.removeLayer(layer);
          const flatLatLngs = layer.getLatLngs()[0].map(coord => [coord.lat, coord.lng]);
          flatLatLngs.push(flatLatLngs[0])
          for (let i = 0; i < this.formes.coordinates.length; i++) {
            const index = this.formes.coordinates[i].findIndex(subArray => subArray.every((tab, index) => tab.every((val, valId) => val === flatLatLngs[index][valId])))
            if (index !== -1) {
              this.formes.coordinates[i].splice(index, 1);
            }
          }

        });


      } else {
        console.error("Aucune couche supprimée trouvée.");
      }
      
      this.$forceUpdate();
    },

    //gere la selection des mpp a droite
    selecting(index) {
      if (this.indexSelect === null) {
        this.formes.ptDeMesure[index] = this.ptDeMesure[index];
        this.indexSelect = index;
      }
      else if (this.indexSelect === index) {
        this.indexSelect = null;
      }
      else {
        this.formes.ptDeMesure[index] = this.ptDeMesure[index];
        this.indexSelect = index;
      }
    },

    //verifie si des mpp ne sont attribuer a aucun blocs
    missingPoints() {
      for (let i = 0; i < this.ptDeMesure.length; i++) {
        if (this.formes.coordinates[i].length === 0) {
          return true;
        }
      }
      return false;
    },

    //permet de gerer la couleur des mpp dans le tableau de droite
    isAllocated(index) {
      if (this.formes.coordinates.length > 1) {
        if (this.formes.coordinates[index].length > 0) {
          return true;
        }
      }
      return false;
    },

    toggleOeil(index) {
      this.exandedIndexOeil = this.exandedIndexOeil === index ? null : index;
    },

    mppSelectBloc(polygon) {
      if (this.exandedIndexOeil != null)
        return polygon.options.mpp.includes(this.formes.ptDeMesure[this.exandedIndexOeil]);
    },

    getStylePolygon(layer) {
      let color = 'blue';
      let fcolor = (this.mppSelectBloc(layer)) ? 'red' : 'blue';
      return {
        color: color,
        fillColor: fcolor,
      }
    },

    getTooltipText(layer) {
      var tooltipText = null;
      if (layer.options.mpp.length < 1) {
        tooltipText = this.$t('_pas_de_point_associe_')
      }
      else {
        tooltipText = this.$t('_point_associe_') + ' : ' + this.getNamesFromIds(layer.options.mpp)
      }
      return tooltipText;
    },

    getIconSource(iconType) {
      if (iconType === 'polygon') {
        return '/img/polygone-button.PNG'; // Define the icon for the polygon button
      } else if (iconType === 'bin') {
        return '/img/bin-button.PNG'; // Define the icon for the bin button
      }
      return ''; // Default/fallback icon si besoin
    }

  }
}

</script>

<style scoped>
.map {
  height: 40vh;
  width: 40vw;
  float: left;
}

.small-map-sep {
  aspect-ratio: 1 / 2;
  z-index: 0;
}

.modal-container-sep {
  width: 60vw;
  height: 60vh;
  margin: 0px auto;
  padding: 20px;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  border-radius: 0.25rem;
  display: flex;
  flex-wrap: wrap;
}

.modal-header-sep {
  font-weight: bold;
  font-size: 1.4rem;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body-sep {
  /* margin-top: 20px ; */
  flex: 1;
  display: flex;
  align-items: center;
  /* height: auto; */
  /* justify-content: center; */
}

.modal-default-button {
  float: right;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.mpp {
  width: 20vw;
  margin: 10px;
  /* float: right; */
  border-collapse: collapse;
  table-layout: fixed;
  align-self: center;
}

th,
td {
  /* border: 1px solid #ccc; */
  padding: 10px;
  text-align: left;
  /* cursor: pointer; */
}

.ligneAssociee {
  border-style: solid;
  border-width: 1px;
  border-color: #242424;
  background-color: #EEEEEE;
  width: 90%;
}

.ligneNonAssocie {
  border-style: solid;
  border-width: 1px;
  border-color: #242424;
  background-color: #d38282;
  width: 90%;
}

.ligneSelected {
  border-style: solid;
  border-width: 1px;
  border-color: #242424;
  background-color: #2546da;
  width: 90%;
}

.eye-select {
  float: right;
  /* background-color: aqua; */
  width: 3vw;
  color: #2546da;
  font-weight: bold;
  font-size: large;
}

.eye {
  float: right;
  /* background-color: aqua; */
  width: 3vw;
  color: #000000;
  font-size: large;
}

.modal-footer-sep {
  align-self: flex-end;
}

.col {
  padding-top: 0;
  padding-bottom: 0;
}
</style>